import { BaseEditor, Descendant } from 'slate';
import { ReactEditor } from 'slate-react';
import { HistoryEditor } from 'slate-history';
import { Quote } from './DiscussionPost';

export type CustomEditor = BaseEditor & ReactEditor & HistoryEditor;

export enum ElementTypes {
  paragraph = 'paragraph',
  bulletedList = 'bulleted-list',
  numberedList = 'numbered-list',
  listItem = 'list-item',
  link = 'link',
  image = 'image',
  mention = 'mention',
  quote = 'quote',
}

export enum MarkTypes {
  bold = 'bold',
  italic = 'italic',
  underline = 'underline',
  strikethrough = 'strikethrough',
}

export enum MarkHtmlTypes {
  bold = 'STRONG',
  italic = 'EM',
  underline = 'U',
  strikethrough = 'S',
}

export type BasicElement = {
  type: ElementTypes.paragraph |
  ElementTypes.bulletedList |
  ElementTypes.numberedList |
  ElementTypes.listItem,
  children: Descendant[],
};

export type LinkElement = {
  type: ElementTypes.link,
  url: string,
  children: CustomText[],
};

export type ImageElement = {
  type: ElementTypes.image,
  url: string,
  children: CustomText[],
};

export type MentionElement = {
  type: ElementTypes.mention,
  username: string,
  userId: string,
  children: CustomText[],
};

export type QuoteElement = {
  type: ElementTypes.quote,
  quoteId: string,
  children: CustomText[],
} & Quote;

export type CustomElement = BasicElement
| LinkElement
| ImageElement
| MentionElement
| QuoteElement;

export type CustomText = {
  bold?: boolean,
  italic?: boolean,
  underline?: boolean,
  strikethrough?: boolean,
  text: string,
};

declare module 'slate' {
  interface CustomTypes {
    Editor: CustomEditor,
    Element: CustomElement,
    Text: CustomText,
  }
}
